module.exports = __webpack_public_path__ + "static/media/logo-full-w.5ea0b850.svg";